import { useMemo } from 'react';
export function useToolbarButtons(props) {
    const { toolbar, selectedKeys, selectedDataSource } = props;
    return useMemo(() => {
        const temp = toolbar?.buttons || [
            // @ts-ignore  兼容 PC => H5 一码多端情况
            ...(toolbar?.toolArea || []),
            // @ts-ignore  兼容 PC => H5 一码多端情况
            ...(toolbar?.batchArea || []),
        ];
        return temp
            .map((item) => {
            try {
                if (typeof item === 'function')
                    return item([], []);
                return item;
            }
            catch { }
            return null;
        })
            .map((item) => {
            try {
                if (typeof item.disabled === 'function') {
                    const disabled = item.disabled([...selectedKeys], selectedDataSource);
                    return { ...item, disabled };
                }
                return item;
            }
            catch { }
            return null;
        })
            .filter((item) => {
            // 无 children 时隐藏不展示
            if (!item?.children)
                return false;
            // @ts-ignore hack 去掉导入导出组件
            if (item.props?.createService)
                return false;
            return true;
        });
    }, [selectedDataSource, selectedKeys, toolbar]);
}
